<div
	class="grid items-center grid-cols-2 bg-white border-t border-gray-200 sm:grid-cols-12"
	[ngClass]="customStyles()"
>
	<p
		class="py-4 text-base font-medium text-gray-500 sm:col-span-7 sm:px-6 whitespace-nowrap"
	>
		{{ providerDetail() }}
	</p>
	<p
		class="py-4 text-base font-medium text-right text-gray-900 sm:col-span-5 sm:text-left sm:pr-6"
	>
		@if (!entryPoints()) {
			{{ data() ? data() : 'Unknown' }}
		}
		<!-- when entry points has value -->
		@if (entryPoints(); as entryPoints) {
			@if (entryPoints.length >= 1) {
				@for (point of entryPoints; track point; let last = $last) {
					{{ point }}{{ last ? '' : ', ' }}
				}
			}
			<!-- when entry points has no value -->
			@if (entryPoints.length === 0) {
				Unknown
			}
		}
	</p>
</div>
